<script lang="ts">
	import CmsImage from '$lib/components/CmsImage.svelte';
	import DefaultContentContainer from '$lib/components/DefaultContentContainer.svelte';
	import EventTileList from '$lib/components/EventTileList.svelte';
	import LoadingIndicator from '$lib/components/LoadingIndicator.svelte';
	import type { PageData } from './$types';
	import { _, locale } from 'svelte-i18n';
	import { getCmsTranslationForLocale } from '$lib/cms';

	export let data: PageData;

	$: translation = getCmsTranslationForLocale(data.category.translations, $locale);
</script>

<svelte:head>
	<title>{translation.title} &mdash; {$_('page.title')}</title>

	{#if translation.meta_description}
		<meta name="description" content={translation.meta_description} />
	{/if}
</svelte:head>

<DefaultContentContainer>
	<h1>{translation.title}</h1>

	<div class="flex">
		{#if data.category.header_image}
			<CmsImage
				image={data.category.header_image}
				href={data.category.header_image_url}
				hover={true}
			/>
		{/if}

		{#if translation.description}
			{@html translation.description}
		{/if}

		{#if data.events}
			<EventTileList events={data.events} />
		{:else}
			<LoadingIndicator />
		{/if}
	</div>
</DefaultContentContainer>

<style>
	.flex {
		display: flex;
		flex-flow: column nowrap;
		gap: 1rem;
	}
</style>
